import { forwardRef } from "react";
import { Box } from "@mui/material";

/**
 * CSS-3D phone shell. Children render inside the screen; screens size themselves with
 * container units (cqw), so they scale with the phone. Animate the root via ref (GSAP).
 */
const PhoneModel = forwardRef(({ children, width = 280, sx = {} }, ref) => (
  <Box sx={{ perspective: 1400, width, maxWidth: "100%", ...sx }}>
    <Box
      ref={ref}
      sx={{
        position: "relative",
        transformStyle: "preserve-3d",
        aspectRatio: "472 / 1024",
        borderRadius: "13% / 6%",
        bgcolor: "#0b0b12",
        p: "2.6%",
        boxShadow:
          "0 0 0 2px #2a2a3a, 0 50px 90px rgba(94,53,177,0.45), 0 20px 40px rgba(0,0,0,0.5), inset 0 0 0 1px rgba(255,255,255,0.08)",
        willChange: "transform",
      }}
    >
      <Box sx={{ position: "relative", width: "100%", height: "100%", borderRadius: "11% / 5%", overflow: "hidden", bgcolor: "#fff", containerType: "inline-size" }}>
        {children}
        {/* camera dot */}
        <Box sx={{ position: "absolute", top: "1.4%", left: "50%", width: "3%", aspectRatio: "1", borderRadius: "50%", bgcolor: "#0b0b12", transform: "translateX(-50%)", zIndex: 5 }} />
      </Box>
    </Box>
  </Box>
));

export default PhoneModel;
